<template>
    <a 
        :href="url"
        class="news-block"
    >
        <div class="news-block__inner">
            <div class="news-block__content">
                <h3 class="news-block__title animate__animated  animate__fadeIn">{{ title }}</h3>
            </div>
            <div class="news-block__meta">
                <div class="news-block__meta-text animate__animated animate__fadeIn">
                    <span>{{ type }}</span>
                    <span>{{ published }}</span>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import axios from 'axios';

export default {
    props: ["url", "title", "type", "published"],
    data() {
        return {}
    }
}
</script>

